import { render, staticRenderFns } from "./RepeatingSection.vue?vue&type=template&id=dfc0ae7c"
import script from "./RepeatingSection.vue?vue&type=script&lang=js"
export * from "./RepeatingSection.vue?vue&type=script&lang=js"
import style0 from "./RepeatingSection.vue?vue&type=style&index=0&id=dfc0ae7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_be517b630ad34e2df4a68e8854480672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports